"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var constants_1 = require("../../constants");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        startAdorment: {
            minHeight: function (props) { return props.textFieldHeight; },
            backgroundColor: '#f0f0f0',
            paddingRight: theme.spacing(1.5),
            borderRight: "1px solid ".concat(theme.palette.divider),
            flexShrink: 0,
        },
        startAdormentText: {
            width: '87px',
            paddingLeft: theme.spacing(1.5),
        },
    });
});
var FormStartAdorment = function (_a) {
    var children = _a.children;
    var classes = useStyles({
        textFieldHeight: constants_1.TEXT_FIELD_HEIGHT,
    });
    return (react_1.default.createElement(core_1.InputAdornment, { className: classes.startAdorment, position: "start" },
        react_1.default.createElement(core_1.Typography, { className: classes.startAdormentText, color: "textSecondary" }, children)));
};
exports.default = FormStartAdorment;
